import {CPSConstants} from "commonUtils/enumerations";

export interface ParamsProps {
  announcementKey: number;
  content: string;
  filePath: string;
  fromDate: string;
  sendBy: string;
  sentWhen: string;
  subject: string;
}

export interface HeaderRecordProps {
  field: string;
  hideable: boolean;
  headerName: string;
  editable?: boolean;
  sortable?: boolean;
  filterable?: boolean;
  disableColumnMenu?: boolean;
  minWidth?: number;
  wrap?: boolean;
  headerAlign?: string;
  renderCell?: (params: unknown) => void;
  flex?: number;
}

export interface MessageDataProps {
  announcementKey: number;
  content: string;
  filePath: string;
  fromDate: string;
  sentBy: string;
  sentWhen: string;
  subject: string;
}

export interface MessageListDialogProps {
  listMessageDialog: boolean;
  viewAllRecords: MessageDataProps[];
  setViewAllRecords: React.Dispatch<React.SetStateAction<MessageDataProps[]>>;
  showAlert: boolean;
  deletedMessage: string;
  setListMessageDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  columns: HeaderRecordProps[];
  loader: boolean;
  setLoader: React.Dispatch<React.SetStateAction<boolean>>;
  errorMsg: string;
  setErrorMsg: React.Dispatch<React.SetStateAction<string>>;
  messages: MessageDataProps[];
  messageYear: number;
  setMessageYear: React.Dispatch<React.SetStateAction<number>>;
  dialogRef: React.Ref<HTMLDivElement> | null;
}

export interface AttachRecordProps {
  fileExtension: string | undefined | unknown;
  fileName: string;
  file: string;
  messageCode?: number;
  message: string;
  isSuccessMessage: boolean;
  isErrorMessage: boolean;
  isValidationMessage: boolean;
}

export const dashBoardMessageStyle = {
  paperPropsViewAttachDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "100rem",
    minHeight: "45rem",
  },
  paperPropUDialog: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "100rem",
    minHeight: "30rem",
    "& .MuiDialogContent-root": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      p: "20px !important",
    },
  },
  firstParaStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    pt: "0.5rem",
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: "bold",
  },
  secondHeadingStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    mt: "0.5rem",
    mb: "0.5rem",
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: "bold",
  },
  marginTopOneStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    mt: "0rem",
  },
  completedTextStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    fontSize: CPSConstants.FONTREMTEXT,
    border: "0.5rem",
  },
  dataGridStyle: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#C1EA94",
      fontFamily: CPSConstants.FONT_FAMILY as string,
    },
    "& .MuiDataGrid-columnHeaderDraggableContainer": {fontFamily: "Montserrat"},
    "& .MuiDataGrid-columnHeaderTitleContainer": {fontFamily: "Montserrat"},
    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      fontWeight: "bold",
    },
    "& .MuiDataGrid-virtualScroller": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      overflow: "hidden",
      minHeight: "25rem",
    },
    "& .MuiDataGrid-colCell": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      height: "auto",
    },
    "& .MuiDataGrid-row": {
      fontFamily: CPSConstants.FONT_FAMILY as string,
      fontSize: CPSConstants.FONTREMTEXT,
      "& .MuiDataGrid-cell": {
        fontFamily: CPSConstants.FONT_FAMILY as string,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        padding: "10px 10px",
        lineHeight: "normal !important",
        whiteSpace: "normal !important",
        wordWrap: "break-word",
      },
    },
  },
  centerTheDialogContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    display: "flex",
    justifyContent: "center",
  },
  iframeContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "100rem",
    height: "45rem",
  },
  iframeDiscorveryDialogContent: {
    fontFamily: CPSConstants.FONT_FAMILY as string,
    minWidth: "100rem",
    height: "38rem",
  },
};
